<template>
  <div class='recruit'>
    <div class="title">
      <img src="@/assets/joinus/register/title.png" alt="">
      <div class="title-tips">
        如有适合您的岗位，感谢您把简历发送至<a class="mailLink" href="mailto:zhangjing@skshu.com.cn">zhangjing@skshu.com.cn</a>邮箱，邮件主题格式为【姓名_招聘职位】，附件为个人简历，文件名为【姓名简历】。如有面试需求，我们会通过电话或邮件方式及时联系您，请留意您的电话或邮箱，以免错过面试机会。
      </div>
    </div>

    <div class="type">
      <div>社会招聘</div>
      <div class="line"></div>
    </div>

    <div class="list">
      <div class="list-tit">
        <span v-for="(item, index) in table" :key="index" :class="`item${index + 1}`">{{ item }}</span>
      </div>

      <div class="list-item" @click="toInfo(item.id)" v-for="(item, index) in list" :key="index">
        <div class="hot" v-if="item.is_hot === 1">热招</div>
        <span class="item1">{{ item.job_name }}</span>
        <span class="item2">{{ item.class_name }}</span>
        <span class="item3">{{ item.job_location }}</span>
        <span class="item4">{{ item.need_num == 0? '若干': item.need_num }}</span>
        <span class="item5">{{ item.job_type == 1? '全职': '兼职' }}</span>
        <span class="item6">{{ item.publish_time.slice(0, 10) }}</span>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
const md5 = require('js-md5')
import qs from 'qs'
import Des from '@/util/des.js'

export default {
  name: 'recruit',
  components: {
  },
  data() {
    return {
      table: ['职位名称', '职位类别', '工作地点', '招聘人数', '工作类型', '发布时间'],
      list: []
    }
  },
  computed: { },
  watch: {},
  created() {
    this.getList()
  },
  mounted() {
  },
  methods: {
    toInfo(id) {
      location.href = this.$Path + '/#/joinus/recruit/info?id=' + id
    },
    getList() {
      const stamp = Date.now()
      const data = {
        stamp,
        keyword: '',
        pageNum: 1,
        pageSize: 100,
        sign: md5(11001 + '' + stamp + atob(localStorage.getItem('okey')))
      }
      axios.post('/api/xiaosen/user/info/recruitJobList', qs.stringify(data)).then(res => {
        if (res.data.result === 1) {
          console.log(res)
          const deskey = atob(localStorage.getItem('odeskey'))
          this.list = JSON.parse(Des.decryptByDES(res.data.dataList, deskey))
          // console.log(this.list)
        } else {
          this.$message(res.data.msg)
        }
      })
    },
    gologin() {
      this.$emit('needLogin', true)
    },
    goregister() {
      this.$emit('goregister', true)
    }
  }
}
</script>
<style lang='less' scoped>
.recruit {
  margin: 0 auto;
  width: 100%;
  max-width: 1920px;
  .title{
    position: relative;
    width: 100%;
    max-width: 1920px;
    img{
      vertical-align: top;
      width: 100%;
    }
    .title-tips {
      width: 628px;
      padding: 73px 41px 68px 43px;
      font-size: 30px;
      font-family: FZLanTingHeiS-R-GB;
      font-weight: 400;
      color: #333333;
      line-height: 55px;
      background: #F5F8F4;
      box-shadow: 0px 0px 60px 0px rgba(0,0,0,0.59);
      opacity: 0.6;
      border-radius: 30px;
      position: absolute;
      top: 214px;
      right: 239px;
      text-align: left;
      word-break: break-all;
      .mailLink {
        color: #333333;
      }
    }
  }

  .type{
    margin: 0 auto;
    padding-top: 49px;
    width: 1440px;
    text-align: left;
    font-size: 24px;
    font-family: FZLanTingHeiS-DB-GB;
    font-weight: 400;
    color: #4E8B46;
    .line{
      width: 98px;
      height: 4px;
      background: #4E8B46;
      margin-top: 11px;
    }
  }

  .list{
    width: 1440px;
    margin: 0 auto;
    margin-bottom: 48px;
    .list-tit{
      margin-top: 38px;
      display: flex;
      width: 1440px;
      height: 72px;
      line-height: 72px;
      background: #F5F8F4;
      border-radius: 15px;
      font-size: 20px;
      font-family: FZLanTingHeiS-R-GB;
      font-weight: 400;
      color: #595858;
      text-align: left;
    }
    .list-item{
      display: flex;
      position: relative;
      width: 1440px;
      height: 80px;
      line-height: 80px;
      font-size: 20px;
      font-family: FZLanTingHeiS-R-GB;
      font-weight: 400;
      text-align: left;
      border-bottom: 1px solid #E4E4E4;
      cursor: pointer;
      .hot{
        position: absolute;
        text-align: center;
        width: 48px;
        border-radius: 10px 0 10px 0;
        height: 20px;
        line-height: 20px;
        background: #009538;
        font-size: 12px;
        font-family: FZLanTingHeiS-R-GB;
        font-weight: 400;
        color: #FFFFFF;
        left: 0;
        top: 30px;
      }
      span{
        box-sizing: border-box;
        padding-right: 20px;
      }
    }
    .item1{
      flex: 1;
      padding-left: 72px;
    }
    .item2{
      width: 191px;
    }
    .item3{
      width: 192px;
    }
    .item4{
      width: 192px;
    }
    .item5{
      width: 192px;
    }
    .item6{
      width: 192px;
    }
  }
}
</style>
